// extracted by mini-css-extract-plugin
module.exports = {"contacts":"Contact_contacts__2Td9n","icons":"Contact_icons__1Nd17","call":"Contact_call__3GIlc","numMail":"Contact_numMail__3HTvN"};